var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5V11.6567C19 10.6871 18.6149 9.75709 17.9293 9.07135C17.2437 8.38561 16.3139 8.00025 15.3442 8H9.65486C8.68536 8.00049 7.75574 8.38597 7.07037 9.07168C6.385 9.7574 6 10.6872 6 11.6567V14.5C6 15.3536 6.16813 16.1988 6.49478 16.9874C6.82144 17.7761 7.30022 18.4926 7.90381 19.0962C8.50739 19.6998 9.22394 20.1786 10.0126 20.5052C10.8012 20.8319 11.6464 21 12.5 21C13.3536 21 14.1988 20.8319 14.9874 20.5052C15.7761 20.1786 16.4926 19.6998 17.0962 19.0962C17.6998 18.4926 18.1786 17.7761 18.5052 16.9874C18.8319 16.1988 19 15.3536 19 14.5Z",
    stroke: "#EB5757",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V8.09091C16 7.00593 15.5786 5.96539 14.8284 5.1982C14.0783 4.43101 13.0609 4 12 4C10.9391 4 9.92172 4.43101 9.17157 5.1982C8.42143 5.96539 8 7.00593 8 8.09091V9",
    stroke: "#EB5757",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.0769H21M5.7 14.0769H3M14.25 4.38462L16.5 3M9.75 4.38462L7.5 3M19.65 19.6154L17.85 18.8769M19.65 8.53846L17.85 9.27692M4.35 19.6154L6.15 18.8769M4.35 8.53846L6.15 9.27692M12 21V15",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.807bb1a8ddfe1d08fe9f13ebba9114c8.svg";
export { ForwardRef as ReactComponent };